export const getReloadTimeoutList = (t: (text: string, fields?: unknown, isMatch?: boolean) => string) => {
  return [
    { value: 30, name: t('30 _[seconds]_') },
    { value: 45, name: t('45 _[seconds]_') },
    { value: 60, name: t('1 _[minute]_') },
    { value: 120, name: t('2 _[minutes]_') },
    { value: 300, name: t('5 _[minutes]_') },
    { value: 600, name: t('10 _[minutes]_') },
    { value: 1800, name: t('30 _[minutes]_') },
    { value: 3600, name: t('1 _[hour]_') },
  ];
};
